<template>
    <div class="c-undefeated">
    <img class="c-undefeated__img" src="@/assets/15_0.png" alt="15 - 0" />
    </div>
</template>

<script>
    export default {
        name: 'Undefeated', 
        data: () => ({
        }),

        computed: {
        },
        methods:{
        },
        mounted(){
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";
    .c-undefeated{
        margin:0 auto;
        width:120px;  
        z-index: 1; 
        pointer-events: none;
        padding:24px 0;
        &__img{
            max-width:100%;
        }
    }
    @media all and (min-width:$small-breakpoint){
        .c-undefeated{
            padding:0;
            position: fixed; 
            bottom: 96px; 
            right: 10vw;
            @include transform(translateX(50%)); 
        }

    }
</style>